import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增菜单", -1)
const _hoisted_4 = { class: "nav flex" }
const _hoisted_5 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = { class: "flex flexR mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/framework/menuAdd" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { class: "bg-red mar-r-10" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("p", {
        class: ["mar-r-20", {
                    'nav-range c-red': _ctx.menuType == 1,
                }],
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuType = 1))
      }, " PC端 ", 2),
      _createVNode("p", {
        class: {
                    'nav-range c-red': _ctx.menuType == 2,
                },
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menuType = 2))
      }, " 手机端 ", 2)
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "200"
          }, {
            default: _withCtx((scope) => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: {
                                    path: '/framework/menuAdd',
                                    query: {
                                        id: scope.row.id,
                                        type: _ctx.menuType,
                                    },
                                }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { class: "btn mar-r-10" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_el_button, {
                  class: "btn mar-r-10",
                  onClick: ($event: any) => (_ctx.setStatus(scope.row.id, 1))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode("div", null, [
                  _createVNode(_component_el_switch, {
                    modelValue: scope.row.status,
                    "onUpdate:modelValue": ($event: any) => (scope.row.status = $event),
                    "active-value": 1,
                    "active-color": "#ff4949",
                    "inactive-color": "#909399",
                    "inactive-value": 0,
                    onChange: ($event: any) => (_ctx.setStatus(scope.row.id, 2))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
}